module.exports = __webpack_public_path__ + "static/media/S2N3-3.80aa7d1a.svg";